import React from "react";
import DPButton, { DPButtonProps } from "Components/DP/DPButton/DPButton";

export interface DPExportButtonProps extends DPButtonProps {
  handleExport: () => void;
  disabled?: boolean;
}

const DPExportButton = ({ handleExport, disabled, ...rest }: DPExportButtonProps) => {
  return (
    <DPButton disabled={disabled} onClick={handleExport} {...rest}>
      Export
    </DPButton>
  );
};

export default DPExportButton;
